function injectStyle (ssrContext) {
  require("!!vue-style-loader!cache-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2fa12fb4\",\"scoped\":true,\"hasInlineConfig\":false}!fast-sass-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./vms-vehicle-count.vue")
}
var normalizeComponent = require("!../../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!cache-loader!happypack/loader?id=babel!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./vms-vehicle-count.vue"
import __vue_script__ from "!!cache-loader!happypack/loader?id=babel!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./vms-vehicle-count.vue"
/* template */
import __vue_template__ from "!!cache-loader!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2fa12fb4\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./vms-vehicle-count.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2fa12fb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared/home-modules/header/vms-vehicle-count.vue
// module id = null
// module chunks = 